/**
 * Automation constants for Script Creator / Script Manager (legacy path).
 * Same behavior as `AutomationStudio/constant`; duplicated until Record/Replay routes are removed.
 * Do not import this from Automation Studio — use `./constant` under `AutomationStudio` instead.
 */

/** Backend / MCP tool name for AI evaluation steps (verification). */
const EVALUATION_TOOL = 'evaluateTestStep';

/**
 * MCP / plan tools that do not use element selectors (single source of truth for UI + validators).
 * Aligned with nlp_automation_phase2 `TOOLS_WITH_NO_LOCATORS` and Script Manager behavior.
 */
const TOOLS_WITHOUT_ELEMENTS = Object.freeze([
  'browser_navigate',
  'browser_navigate_back',
  'browser_navigate_forward',
  'browser_snapshot',
  'browser_evaluate',
  'browser_file_upload',
  'browser_handle_dialog',
  'browser_screenshot',
  'browser_take_screenshot',
  'browser_console',
  'browser_console_messages',
  'browser_network',
  'browser_network_requests',
  'browser_press_key',
  'browser_wait',
  'browser_wait_for',
  'browser_close',
  'browser_run_code',
  'browser_resize',
  'browser_install',
  'browser_refresh',
  'browser_pdf_save',
  'browser_fill_form',
  'browser_generate_playwright_test',
  'browser_tab_list',
  'browser_tab_new',
  'browser_tab_select',
  'browser_tab_close',
  'browser_tabs',
  EVALUATION_TOOL,
]);

/** Legacy / MCP alias names mapped before selector checks. */
const TOOL_NAME_ALIASES = Object.freeze({
  browser_screenshot: 'browser_take_screenshot',
  browser_console: 'browser_console_messages',
});

function normalizeToolName(toolName) {
  if (!toolName || typeof toolName !== 'string') return toolName;
  return TOOL_NAME_ALIASES[toolName] ?? toolName;
}

function toolSupportsElements(toolName) {
  const normalized = normalizeToolName(toolName);
  if (!normalized || typeof normalized !== 'string') return false;
  if (normalized.startsWith('browser_tab_')) return false;
  return !TOOLS_WITHOUT_ELEMENTS.includes(normalized);
}

// Arguments that are internal plumbing and should not be shown/edited in the UI.
const SKIP_ARGUMENTS = ['ref', 'startRef', 'endRef', 'instructionId'];
const ONLY_CUSTOM_ARGUMENTS = ['selector', 'startSelector', 'endSelector'];
const EXECUTION_STEPS_TITLE = 'Execution Steps';

const EXECUTION_MODES = Object.freeze({
  SMART: 'playwright',
  XPATH_ONLY: 'tool',
});

const ALLOWED_TYPES = ['xpath_custom', 'xpath_custom_drag', 'xpath_playwright', 'xpath_rules'];
const LABEL_MAP = {
  xpath_dynamic: 'Dynamic Selector',
  xpath_custom: 'Custom Selector',
  xpath_playwright: 'Targeted Selector',
  xpath_rules: 'Resilient Selector',
};

export {
  TOOLS_WITHOUT_ELEMENTS,
  toolSupportsElements,
  SKIP_ARGUMENTS,
  ONLY_CUSTOM_ARGUMENTS,
  EXECUTION_STEPS_TITLE,
  EXECUTION_MODES,
  ALLOWED_TYPES,
  LABEL_MAP,
  EVALUATION_TOOL,
};
